import React, { Fragment } from "react";
import PropTypes from "prop-types";
import ProductSchedulesForm from "./ProductSchedulesForm";
import ScheduleRow from "./ScheduleRow";
import EmptyTd from "./EmptyTd";
import _ from "underscore";

export default class SingleProduct extends React.Component {
  state = {
    showScheduleForm: false,
    selectedSchedules: []
  };

  toggleScheduleForm = () =>
    this.setState(state => ({ showScheduleForm: !state.showScheduleForm }));

  addNewSchedule = () => {
    const { showScheduleForm } = this.state;
    if (showScheduleForm) this.productScheduleForm.addNewScheduleForm();
    else this.toggleScheduleForm();
  };

  selectProduct = () => {
    const { product, selectProduct } = this.props;
    selectProduct(product);
  };

  componentWillUnmount() {}

  selectSchedule = schedule => {
    var newSelectedSchedules;
    const { selectedSchedules } = this.state;
    const { product, updateSelectedSchedulesForProduct } = this.props;
    if (this.isScheduleSelected(schedule))
      newSelectedSchedules = selectedSchedules.filter(s => !_.isEqual(s, schedule));
    else newSelectedSchedules = selectedSchedules.concat(schedule);
    this.setState({ selectedSchedules: newSelectedSchedules });
    updateSelectedSchedulesForProduct(product, newSelectedSchedules);
  };

  isScheduleSelected = schedule => {
    const { selectedSchedules } = this.state;
    return selectedSchedules.some(s => _.isEqual(schedule, s));
  };

  render() {
    const { product, selected, reloadProduct, company_id } = this.props;
    const { showScheduleForm, selectedSchedules } = this.state;
    return (
      <Fragment>
        {product.schedules.length == 0 ? (
          <ScheduleRow
            isProductSelected={selected}
            showProduct={true}
            product={product}
            reloadProduct={reloadProduct}
            addNewSchedule={this.addNewSchedule}
            selectProduct={this.selectProduct}
          />
        ) : (
          product.schedules.map((schedule, index) => (
            <ScheduleRow
              isProductSelected={selected}
              showProduct={index == 0}
              key={index}
              product={product}
              schedule={schedule}
              reloadProduct={reloadProduct}
              addNewSchedule={this.addNewSchedule}
              selectProduct={this.selectProduct}
              isScheduleSelected={this.isScheduleSelected(schedule)}
              selectSchedule={() => this.selectSchedule(schedule)}
            />
          ))
        )}
        {showScheduleForm && (
          <tr>
            <EmptyTd colSpan={7}>
              <ProductSchedulesForm
                product={product}
                company_id={company_id}
                ref={ref => (this.productScheduleForm = ref)}
                toggleScheduleForm={this.toggleScheduleForm}
                reloadProduct={() => reloadProduct(product.id)}
              />
            </EmptyTd>
          </tr>
        )}
        {!showScheduleForm &&
          product.schedules.length > 1 && (
            <tr>
              <EmptyTd colSpan={7} style={{ border: 0 }} />
            </tr>
          )}
      </Fragment>
    );
  }
}

SingleProduct.propTypes = {
  product: PropTypes.object,
  selected: PropTypes.bool,
  company_id: PropTypes.number,
  reloadProduct: PropTypes.func,
  selectProduct: PropTypes.func
};
